export default __webpack_public_path__ + "static/data-analytics-94e7697abaf6de803b140b58a4090b65.webp";